<template>
    <div 
        v-tinymce="options"
        :key="renderKey"
        @mce-change="(title) => offerSectionSet({title: title})"
        @mce-dirty="() => $emit('dirty')"
    >
        <div v-if="offerSections.title" v-html="offerSections.title"></div>
        <div  v-else class="heading">
            <h1 class="mt-0" v-html="$t('heading.offerFor', { type: offerTypeName, appendage: offerTypeAppendage })"></h1>
            <h2>{{ (offer && offer.title) ? offer.title : seminarTitle}} <small v-if="isOpenSeminar" style="line-height:1.2;font-weight:500;font-size:20px">- S{{ seminarId }}</small></h2>
        </div>
    </div>
</template>



<script>

import placeholder from './placeholder';
import { mapGetters, mapMutations } from 'vuex';

export default {
    name: 'Heading',
    mixins: [placeholder],
    props: {
        options: Object,
    },
    data: function() {
        return {
            types: [
                {
                    id: 1,
                    name: 'heading.types.inhouse',
                    appendage: 'heading.appendages.customer',
                },
                {
                    id: 2,
                    name: 'heading.types.company',
                    appendage: 'heading.appendages.gfu',
                },
                {
                    id: 3,
                    name: 'heading.types.company',
                    appendage: 'heading.appendages.gfuOrCustomer',
                },
                {
                    id: 4,
                    name: 'heading.types.open',
                    appendage: 'heading.appendages.gfu',
                }
            ],
            renderKey: 0,
        };
    },
    methods: {
        ...mapMutations([
            'offerSectionSet'
        ])
    },
    computed: {
        ...mapGetters([
            'offerType',
            'seminar',
            'offerSections',
            'offer',
        ]),
        offerTypeAppendage() {
            if(this.offer.isRemote)
                return this.$t(this.offer.isClassroom
                    ? 'heading.appendages.onlineOrClassroom'
                    : 'heading.appendages.online');
            return this.offerType
                ? this.$t(this.types.find(({id}) => id === this.offerType.id).appendage)
                : this.placeholder;
        },
        offerTypeName () {
            if(this.offer.isIndividualTraining) return this.$t('heading.types.individual');
            return this.offerType
                ? this.$t(this.types.find(({id}) => id === this.offerType.id).name)
                : this.placeholder;
        },
        isOpenSeminar () {
            return this.offerType && this.offerType.id === 4;
        },
        seminarTitle () {
            return this.seminar 
                ? this.seminar.title
                : this.placeholder;
        },
        seminarId () {
            return this.seminar 
                ? this.seminar.ref_id
                : this.placeholder;
        }
    },
    watch: {
        offerType: function() {
            this.renderKey++;
        },
        offer: function () {
            this.renderKey++;
        },
        seminar: function (){
            this.renderKey++;
        }
    }
}
</script>
